import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Spin } from "antd";
import {
  LOCAL_STORAGE_TOKEN_KEY,
  LOCAL_STORAGE_USER_PHONE_NUMBER,
} from "../../../../configs/auth";
import notificationHandler from "../../../atoms/Notification";

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code") || "";
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const phoneNumber =
      localStorage.getItem(LOCAL_STORAGE_USER_PHONE_NUMBER) ?? "";
    const loginWithSsoUrl = "/login?showSso=1";
    if (!code) {
      const message =
        "Vui lòng bật 4G/5G Viettel để sử dụng đăng nhập bằng MobileID.";
      notificationHandler("error", message);
      navigate(loginWithSsoUrl);
      return;
    }
    if (!phoneNumber) {
      const message = "Missing phone number for exchange request.";
      notificationHandler("error", message);
      navigate(loginWithSsoUrl);
      return;
    }
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";
    if (!apiBaseUrl) {
      const message = "Missing REACT_APP_API_BASE_URL in .env.";
      notificationHandler("error", message);
      navigate(loginWithSsoUrl);
      return;
    }

    const runExchange = async () => {
      try {
        const url = `${apiBaseUrl.replace(
          /\/$/,
          ""
        )}/api/v1/auth/mobile/exchange`;
        const body = {
          code: code,
          client: "viettel-app",
          phone_number: phoneNumber,
        };
        const response = await axios.post(url, body);
        const token = response?.data?.token;
        if (token) {
          localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
          notificationHandler("success", "Đăng nhập thành công");
          navigate("/order-meals");
          return;
        }
        const message =
          response?.data?.msg_content || "Không nhận được access token.";
        notificationHandler("error", message);
        navigate(loginWithSsoUrl);
      } catch (err: any) {
        const message =
          err?.response?.data?.msg_content ||
          err?.message ||
          "Exchange request failed.";
        notificationHandler("error", message);
        navigate(loginWithSsoUrl);
      } finally {
        setLoading(false);
      }
    };

    runExchange();
  }, [code, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Spin spinning={loading} />
    </div>
  );
};

export default AuthCallback;
